import * as React from "react";

import CoreSetupPage from "../../../core_modules/pages/CoreSetupPage";
import CoreListPage from "../../../core/pages/CoreListPage";

export default function OrganizationProfilePage() {
  return (
    <>
  {/* // <PageShell
    //   title="Organization Profile"
    //   subtitle="Organization settings, branches, departments, beds, wards, policies."
      
    // /> */}
    
    {/* <CoreSetupPage/> */} 
    <CoreListPage/>
    </>
  
  );
}